import { axiosClient } from "services/axios";

import {
  AddProductGroupParams,
  EditProductGroupParams,
  GetProductGroupsParams,
} from "../types";

export function getProductGroups({
  page = 1,
  pageSize = 1000,
}: GetProductGroupsParams = {}) {
  return axiosClient
    .get("items/group", {
      params: {
        page,
        pageSize,
      },
    })
    .then((res) => res.data);
}

export function addProductGroup(params: AddProductGroupParams) {
  return axiosClient.post("items/group", params);
}

export function editProductGroup(params: EditProductGroupParams) {
  return axiosClient.put("items/group", params);
}

export function deleteProductGroup(groupId: string) {
  return axiosClient.post("items/delete-group", { group_id: groupId });
}
